/**
 * @typedef {Object} CommentModelType
 * @property {number} id - Unique identifier
 * @property {string} commentText - Comment text or a JSON string
 * @property {string} addedBy - Name of the user who added the comment
 * @property {number} type - Comment type
 * @property {Date} dateCreated - Date comment was created
 * @property {string} [assignedTo] - Name of the user assigned to the comment (nullable)
 * @property {number} [batchID] - ID of the batch the comment belongs to (nullable)
 * @property {string} [commentReference] - Reference type of the comment (nullable)
 * @property {string} [commentReferenceSourceID] - ID of the source the comment is referring to (nullable)
 * @property {string} [commentSubject] - Subject of the comment (nullable)
 * @property {Date} [dateSent] - Date the comment was sent (nullable)
 * @property {string} [destination] - Destination address of the comment (nullable)
 * @property {number} [parentCommentID] - ID of the parent comment (nullable)
 * @property {number} [sendAttempts] - Number of send attempts for the comment (nullable)
 * @property {string} [sendStatus] - Status of the send operation (nullable)
 */

import DateFormatToken from '@/constants/date/DateFormatToken'
import dayjs from '@/services/date/index'

/**
 * @class
 */
export default class CommentModel {
  /**
   * Create a new CommentModel.
   * @param {CommentModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.commentText = params.commentText
    this.addedBy = params.addedBy
    this.type = params.type
    this.dateCreated = params.dateCreated ? dayjs(params.dateCreated) : null
    this.assignedTo = params.assignedTo || null
    this.batchID = params.batchID || null
    this.commentReference = params.commentReference || null
    this.commentReferenceSourceID = params.commentReferenceSourceID || null
    this.commentSubject = params.commentSubject || null
    this.dateSent = params.dateSent ? dayjs(params.dateSent) : null
    this.destination = params.destination || null
    this.parentCommentID = params.parentCommentID || null
    this.sendAttempts = params.sendAttempts || null
    this.sendStatus = params.sendStatus || null
  }

  /**
   * Get the formatted date created timestamp
   * @returns {string} - The timestamp text
   */
  getDateCreatedTimestamp() {
    if (!this.dateCreated) return ''
    return dayjs(this.dateCreated).format(DateFormatToken.ddddDoMMMMatLT)
  }
}
